import React, {useContext} from 'react';
import GoogleMapReact from 'google-map-react';
import appContext from '../../Foundations/Contexts/AppContext';
import GoogleApiKey from '../../Foundations/Constants/GoogleApiKey';
import searchFilterContext from '../../Foundations/Contexts/SearchFilterContext';
import resultsContext from '../../Foundations/Contexts/ResultsContext';
import {getSelectedRadiusFromActiveFilters} from '../../Foundations/Utils/SearchFilterUtils';
import MapPinMarker from './MapPinMarker';
import {IDepotSummary} from '../../Foundations/Types/IDepot';
import {getActiveReportFilters, getDepotsWithNoResults} from '../../Foundations/Utils/PDFUtils';
import {ActiveReportFilters} from '../../Foundations/Enum/ActiveReportFilters';

const ReportMapView: React.FC = () => {
    const { env } = useContext(appContext);
    const { resultSummary,  depotsAtArea, selectedRadius} = useContext(resultsContext);
    const { searchParameters, activeFilters } = useContext(searchFilterContext);
    const depotWithNoResults: IDepotSummary[] = resultSummary !== null && resultSummary.depotSummary !== null
        ? getDepotsWithNoResults(depotsAtArea, resultSummary.depotSummary, selectedRadius)
        : [];

    const activeReportFilters: ActiveReportFilters[] = getActiveReportFilters(activeFilters);

    const onMapLoaded = (map) => {
        const selectedRadius = getSelectedRadiusFromActiveFilters(activeFilters);

        if (searchParameters === null) {
            return;
        }

        const remove_poi = [
            {
                "featureType": "poi",
                "elementType": "labels",
                "stylers": [
                    { "visibility": "off" }
                ]
            }
        ];

        map.setOptions({styles: remove_poi});

        // draw radius circle
        const circle = new google.maps.Circle({
            strokeColor: '#0A68FF',
            strokeOpacity: 0.8,
            strokeWeight: 1,
            fillColor: '#0A68FF',
            fillOpacity: 0.1,
            map,
            center: {
                lat: searchParameters.latitude,
                lng: searchParameters.longitude
            },
            radius: selectedRadius * 1000
        });

        map.fitBounds(circle.getBounds(), 0);
        map.setZoom(map.getZoom() + 0.1);
    }

    const getMarkerClassName = (data: IDepotSummary, index: number): string => {
        if (index === 0) {
            return 'fill-orange z-20';
        }

        if (
            resultSummary !== null &&
            resultSummary.lowestPerDay !== null &&
            data.lowestPerDay !== null &&
            data.lowestPerDay.id === resultSummary.lowestPerDay.id) {
            return 'fill-blue z-10';
        }

        return 'fill-blue-600';
    }

    if (searchParameters === null) {
        return null;
    }

    return (
        <div className="h-full w-full">
            <GoogleMapReact
                bootstrapURLKeys={{
                    key: GoogleApiKey[env]
                }}
                yesIWantToUseGoogleMapApiInternals
                onGoogleApiLoaded={({map}) => onMapLoaded(map)}
                defaultCenter={{
                    lat: searchParameters.latitude,
                    lng: searchParameters.longitude
                }}
                options={{ fullscreenControl: false, disableDefaultUI: true}}
                defaultZoom={13}
            >
                {
                    resultSummary !== null &&
                    resultSummary.depotSummary.map((marker, index) => (
                        <MapPinMarker
                            key={index}
                            lat={marker.depot_coordinates.y}
                            lng={marker.depot_coordinates.x}
                            className={getMarkerClassName(marker, index)}
                            zIndex={-(index)}
                            mapNum={index + 1}
                        />
                    ))
                }
                {
                    activeReportFilters.indexOf(ActiveReportFilters.DEPOTS) < 0 &&
                    depotWithNoResults.length > 0 &&
                    depotWithNoResults.map((marker, index) => (
                        <MapPinMarker
                            key={index}
                            lat={marker.depot_coordinates.y}
                            lng={marker.depot_coordinates.x}
                            className="fill-gray-500"
                            zIndex={-((resultSummary !== null ? resultSummary.depotSummary.length : 0) + index)}
                            mapNum={(resultSummary !== null ? resultSummary.depotSummary.length : 0) + index + 1 }
                        />
                    ))
                }
            </GoogleMapReact>
        </div>
    )
}

export default ReportMapView;
